import { render } from "./GastoDialog.vue?vue&type=template&id=fc45b81e"
import script from "./GastoDialog.vue?vue&type=script&lang=js"
export * from "./GastoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__